import React from "react";
import { BsTwitter } from "react-icons/bs";
import { FiPhoneCall } from "react-icons/fi";
import { GrFacebookOption, GrLinkedinOption } from "react-icons/gr";
import { HiLocationMarker } from "react-icons/hi";
import { ImHome3 } from "react-icons/im";
import { IoIosArrowForward } from "react-icons/io";
import { MdMail } from "react-icons/md";
import Logo from "../../assets/images/logo-2.png";
import Bottom from "./Bottom";

const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="container footer-container">
          <div className="part1">
            <div>
              <img src={Logo} alt="" />
            </div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <div className="icons">
              <div className="logo-icon">
                <GrFacebookOption />
              </div>
              <div className="logo-icon">
                <BsTwitter />
              </div>
              <div className="logo-icon">
                <GrLinkedinOption />
              </div>
            </div>
          </div>
          <div className="part2">
            <h5>Quick Links</h5>
            <ul>
              <li>
                <IoIosArrowForward /> home
              </li>
              <li>
                <IoIosArrowForward /> about us
              </li>
              <li>
                <IoIosArrowForward /> services
              </li>
              <li>
                <IoIosArrowForward /> projects
              </li>
              <li>
                <IoIosArrowForward /> pricing
              </li>
              <li>
                <IoIosArrowForward /> contact
              </li>
            </ul>
          </div>
          <div className="part3">
            <h5>Contact Info</h5>
            <div className="contacts">
              <p>
                <HiLocationMarker className="contact-icon" /> 11 Deneside,
                Seghill",NE23
              </p>
              <p>
                <FiPhoneCall className="contact-icon" /> 0 (143) 456 7897 0{" "}
                <br /> <span>(143) 987 6546</span>
              </p>
              <p>
                <MdMail className="contact-icon" /> info@example.com
              </p>
            </div>
          </div>
          <div className="part4">
            <h5>Get in touch</h5>
            <div className="contacts">
              <p>
                <FiPhoneCall className="contact-icon" /> 0 (143) 456 7897
              </p>
              <p>
                <MdMail className="contact-icon" /> info@example.com
              </p>
              <p>
                <ImHome3 className="contact-icon" /> 11 Deneside, Seghill",NE23
              </p>
            </div>
          </div>
        </div>
      </div>
      <Bottom />
    </>
  );
};

export default Footer;
